import React from 'react'
import './pending-game-invites-list.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';

const PendingGameInvitesList = ({
  invites,
  acceptDeclineInvite
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  
  return (
    <div
      className={`pending-game-invites-list ${screenSize}`}>
      <h3>Pending Game Invites</h3>
      {
        Object.values(invites).map((invite) => (
          <div
            key={invite.id}
            className='pending-invite-item g-list-item'>
            <ImageContainer
                src={invite.gameIcon}
                className='game-icon' />
            <div className='game-name'>
              <b>{invite.gameName}</b>
              <div className='meta'>Invited as <b>{invite.role[0]}</b></div>
            </div>
            <div className='invite-date'>
              <div className='meta'>Invited on {new Date(invite.ts_created).toLocaleDateString()}</div>
            </div>
            <div className='buttons'>
              <button
                className='g-button small-btn'
                onClick={() => acceptDeclineInvite(invite, false)}>
                Decline
              </button>
              <button
                className='g-button small-btn primary'
                onClick={() => acceptDeclineInvite(invite, true)}>
                Accept
              </button>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default PendingGameInvitesList